// services/vesselService.js

import { clearUser } from "@store/auth/userSlice";

import axios from "axios";

const handleUnauthorized = (dispatch, navigate) => {
	dispatch(clearUser());
	navigate("/login");
};

export const createVoucherRequest = async (data, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/voucher-request`, // trailing dashes removed — looked like a placeholder leftover
			data,
			config,
		);
		return response.data;
	} catch (error) {
		if (error.response?.status === 401) {
			handleUnauthorized(dispatch, navigate);
			throw new Error("Session expired. Please log in again.");
		}
		if (error.response?.status === 422) {
			throw { errors: error.response.data.errors };
		}
		if (error.response?.status === 400 || error.response?.status === 404) {
			throw new Error(error.response.data?.message || "Unexpected error.");
		}
		console.error("Error creating voucher request:", error);
		throw new Error("Something went wrong");
	}
};
